import script from "./showAccomodation.vue?vue&type=script&setup=true&lang=js"
export * from "./showAccomodation.vue?vue&type=script&setup=true&lang=js"

import "./showAccomodation.vue?vue&type=style&index=0&id=f4470f4e&scoped=true&lang=css"

import exportComponent from "/Users/saameen/Documents/www/hs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4470f4e"]])

export default __exports__